import { render, staticRenderFns } from "./EditAssignment.vue?vue&type=template&id=db8ae79e"
import script from "../../services/assignment/edit-assignment.js?vue&type=script&lang=js&external"
export * from "../../services/assignment/edit-assignment.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/assignment/create-assignment.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports